
document.addEventListener("DOMContentLoaded", function () {

  class YGTimeChange extends HTMLElement {

    constructor() {
      super();
      this._isLocked = false;
      this._isSnapping = false;
      this.init();
    }

    init() {

      this.videos = this.querySelectorAll(".yg-video-item");
      this.media = this.querySelectorAll(".yg-image-item");
      this.contents = this.querySelectorAll(".yg-content-item");

      this.times = this.querySelectorAll(
        ".yg-time-wrapper.hide-mobile .yg-time-item"
      );

      this.timesMobile = this.querySelectorAll(
        ".yg-time-wrapper.hide-pc .yg-time-item"
      );

      this.rightInfoWrapper = this.querySelector(".yg-right-info-wrapper");
      this.extraHeight =
        this.querySelector(".yg-scroll-wrapper").offsetTop;

      this.imageScrollContainer =
        this.querySelector(".yg-image-scroll-container");

      this.stickyContent =
        this.querySelector(".yg-sticky-element");

      this.flags = Array.from(this.media).map(() => 0);

      this.preHeight = 100 / this.media.length;

      this.setMediaHeight();

      this.calcHeadingTop();

      this.currentActiveIndex = 0;
      this.lastActiveIndex = 0;

      this._lastScrollTop = 0;
      this._scrollTicking = false;

      // this.style.setProperty(
      //   "--per-height",
      //   this.media[0].getBoundingClientRect().height + "px"
      // );

      const isMobile = window.matchMedia("(max-width: 989px)").matches;
      if (isMobile && this.rightInfoWrapper && this.stickyContent) {
        const stickyHeight = this.stickyContent.getBoundingClientRect().height;
        const rightInfoHeight = this.rightInfoWrapper.getBoundingClientRect().height;
        const calculatedHeight = stickyHeight - rightInfoHeight;
        this.style.setProperty("--per-height", calculatedHeight + "px");
        this._perHeight = calculatedHeight;
      } else {
        this.style.setProperty(
          "--per-height",
          this.media[0].getBoundingClientRect().height + "px"
        );
        this._perHeight = this.media[0].getBoundingClientRect().height;
      }

      // 保存 section 顶部相对视口的位置，供滑动切换时使用
      this._sectionTop = this.getBoundingClientRect().top + window.scrollY;
      this.handleAnchorTab();
      this.setBackground(); // 初始化背景颜色

      if (isMobile) {
        this.handleMobileSwipe(); // 移动端滑动切换
        return;
      }
      this.handleScroll();       // PC rAF 滚动逻辑
      // this.handleBackgroundChange();
      // this.handleMobileSwipe();
    }

    /* -----------------------------
       时间动画
    ----------------------------- */

    animateClock(startHour, startMinute, endHour, endMinute, duration) {

      const element = this.querySelector(".yg-time-show");
      const elementmb = this.querySelector(".yg-time-show-mb");

      const frameRate = 10;
      const totalFrames = Math.round((duration / 1000) * frameRate);

      let frame = 0;

      const startTotalMinutes = startHour * 60 + startMinute;
      const endTotalMinutes = endHour * 60 + endMinute;
      const diffMinutes = endTotalMinutes - startTotalMinutes;

      const update = () => {

        frame++;

        const progress = frame / totalFrames;

        const currentMinutes =
          startTotalMinutes + diffMinutes * progress;

        const hour = Math.floor(currentMinutes / 60);
        const minute = Math.floor(currentMinutes % 60);

        const text =
          String(hour).padStart(2, "0") +
          ":" +
          String(minute).padStart(2, "0");

        if (element) element.textContent = text;
        if (elementmb) elementmb.textContent = text;

        if (frame < totalFrames) {
          requestAnimationFrame(update);
        }
      };

      requestAnimationFrame(update);
    }

    parseTime(str) {

      if (!str || !str.includes(':')) return { hour: 0, minute: 0 };

      const arr = str.split(":");

      return {
        hour: parseInt(arr[0], 10) || 0,
        minute: parseInt(arr[1], 10) || 0,
      };
    }

    /* -----------------------------
       颜色计算
    ----------------------------- */

    hexToRgb(hex) {

      const result =
        /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

      return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
          }
        : { r: 255, g: 255, b: 255 };
    }

    lerpColor(color1, color2, t) {

      const c1 = this.hexToRgb(color1);
      const c2 = this.hexToRgb(color2);

      const r = Math.round(c1.r + (c2.r - c1.r) * t);
      const g = Math.round(c1.g + (c2.g - c1.g) * t);
      const b = Math.round(c1.b + (c2.b - c1.b) * t);

      return `rgb(${r}, ${g}, ${b})`;
    }

    /* -----------------------------
       滚动高度
    ----------------------------- */

    calcHeadingTop() {
      requestAnimationFrame(() => {
        const temps = this.querySelectorAll(".yg-heading-temp");
        temps.forEach((el) => {
          const w = el.offsetWidth;
          el.style.setProperty("--heading-top", w + 30 + "px");
          el.classList.remove("yg-heading-temp");
        });
      });
    }

    setMediaHeight() {
      let height = 0;
      const isMobile = window.matchMedia("(max-width: 989px)").matches;

      if (isMobile && this.rightInfoWrapper && this.stickyContent) {
        const stickyHeight = this.stickyContent.getBoundingClientRect().height;
        const rightInfoHeight = this.rightInfoWrapper.getBoundingClientRect().height;
        const calculatedHeight = stickyHeight - rightInfoHeight;
        height = this.media.length * calculatedHeight;
      } else {
        this.media.forEach((media) => {
          height += media.getBoundingClientRect().height / 2;
        });
      }

      if (this.querySelector(".section-header")) {
        height +=
          this.querySelector(".section-header")
            .getBoundingClientRect().height;
      }

      this.totalHeight = height;

      this.style.setProperty(
        "--scrolling-height",
        `${height}px`
      );
    }

    /* -----------------------------
       获取当前 index
    ----------------------------- */

    getActiveIndex() {

      let index = 0;

      for (let i = 0; i < this.contents.length; i++) {

        if (!this.contents[i].classList.contains("yg-opacity-0")) {
          index = i + 1;
        } else {
          break;
        }
      }

      return index;
    }

    /* -----------------------------
       视频切换
    ----------------------------- */

    switchVideo(prevIndex, activeIndex) {

      if (!this.videos[activeIndex]) return;

      const prevItem = this.videos[prevIndex];
      const nextItem = this.videos[activeIndex];

      const prevVideo = prevItem?.querySelector('.yg-video');
      const prevReverse = prevItem?.querySelector('.yg-reverse-video');

      const nextVideo = nextItem?.querySelector('.yg-video');
      const nextReverse = nextItem?.querySelector('.yg-reverse-video');

      // 隐藏所有视频容器
      this.videos.forEach(v => v.classList.add('yg-display-none'));

      // 显示当前
      nextItem.classList.remove('yg-display-none');

      // 清理所有 active
      this.querySelectorAll('.yg-video, .yg-reverse-video').forEach(v => {
        v.classList.remove('active');
      });

      // reset video (仅对 video 元素生效)
      [prevVideo, prevReverse, nextVideo, nextReverse].forEach(v => {
        if (!v) return;
        if (v.tagName === 'VIDEO') {
          v.pause();
          v.currentTime = 0;
        }
      });

      // GIF 图片显示逻辑（img.yg-video）
      if (nextVideo && nextVideo.tagName === 'IMG') {
        nextVideo.classList.add('active');
      }

      const isForward = activeIndex > prevIndex;

      let playVideo = null;

      if (isForward) {

        // 正向滚动
        if (prevVideo && prevVideo.tagName === 'VIDEO') {
          prevVideo.classList.add('active');
        }

        playVideo = nextVideo;

      } else {

        // 反向滚动
        if (prevReverse && prevReverse.tagName === 'VIDEO') {
          prevReverse.classList.add('active');
        }

        playVideo = nextReverse || nextVideo;
      }

      // 仅对 video 元素执行播放逻辑
      if (playVideo && playVideo.tagName === 'VIDEO') {

        playVideo.classList.add('active');

        playVideo.muted = true;
        playVideo.playsInline = true;

        const promise = playVideo.play();

        if (promise !== undefined) {
          promise.catch(() => {});
        }
      }

      // 同步背景色
      const bgColor = this.media[activeIndex]?.getAttribute("data-background") || "#ffffff";
      this.stickyContent.style.backgroundColor = bgColor;
    }

    /* -----------------------------
       背景渐变
    ----------------------------- */

    //  setBackground() {

    //   const offsetTop =
    //     this.getBoundingClientRect().top * -1;

    //   let progress = offsetTop / this.totalHeight;

    //   if (progress > 1) progress = 1;
    //   if (progress < 0) progress = 0;

    //   const totalItems = this.media.length;

    //   const itemProgress = progress * (totalItems - 1);

    //   const currentIndex = Math.floor(itemProgress);
    //   const nextIndex = Math.min(
    //     currentIndex + 1,
    //     totalItems - 1
    //   );

    //   const t = itemProgress - currentIndex;

    //   const currentBg =
    //     this.media[currentIndex].getAttribute(
    //       "data-background"
    //     ) || "#ffffff";

    //   const nextBg =
    //     this.media[nextIndex].getAttribute(
    //       "data-background"
    //     ) || currentBg;

    //   const bgColor = this.lerpColor(currentBg, nextBg, t);

    //   this.stickyContent.style.backgroundColor = bgColor;
    // } 

    // handleBackgroundChange() {

    //   this.setBackground();

    //   window.addEventListener("scroll", () => {
    //     this.setBackground();
    //   });
    // }

    switchToIndex(nextIndex) {

      const prevIndex = this.lastActiveIndex;

      if (nextIndex === prevIndex) return;

      // 内容显示
      this.contents.forEach((c, i) => {

        if (i <= nextIndex) {
          c.classList.remove("yg-opacity-0");
        } else {
          c.classList.add("yg-opacity-0");
        }

        c.classList.add("yg-display-none");

      });

      this.contents[nextIndex].classList.remove(
        "yg-display-none"
      );

      // 图片滚动
      this.imageScrollContainer.style.setProperty(
        "--current-index",
        nextIndex
      );

      // 时间动画
      if (this.times.length > 0 && this.times[nextIndex]) {
        const currentTimeStr = this.times[nextIndex].getAttribute("data-time");
        const prevTimeStr = this.times[prevIndex].getAttribute("data-time");
        const currentTime = this.parseTime(currentTimeStr);
        const prevTime = this.parseTime(prevTimeStr);
        const activeTimeItem = this.times[nextIndex];
        const textColor = activeTimeItem.style.getPropertyValue("--text-color");
        const dotColor = activeTimeItem.style.getPropertyValue("--dot-color");

        const timeShow = this.querySelector(".yg-time-show");
        const timeShowMb = this.querySelector(".yg-time-show-mb");
        const timeColor = this.querySelector(".yg-time-color");
        const timeColorMb = this.querySelector(".yg-time-color-mb");

        if (timeShow) timeShow.style.color = textColor;
        if (timeShowMb) timeShowMb.style.color = textColor;
        if (timeColor) timeColor.style.setProperty("--dot-color", dotColor);
        if (timeColorMb) timeColorMb.style.setProperty("--dot-color", dotColor);

        this.animateClock(prevTime.hour, prevTime.minute, currentTime.hour, currentTime.minute, 800);
      }

      // 视频切换
      this.switchVideo(
        prevIndex,
        nextIndex
      );

      this.setBackground(nextIndex);

      this.lastActiveIndex = nextIndex;

    }

    handleMobileSwipe() {
      const MIN_SWIPE = 15;          // 降低阈值
      const LOCK_DURATION = 200;     // 缩短锁定时长

      let startY = 0;
      let startTime = 0;
      let isAnimating = false;
      const onTouchStart = (e) => {
        if (this.stickyContent.getBoundingClientRect().top > 0) {
          return;
        }
        if (isAnimating) return;
        startY = e.touches[0].clientY;
        startTime = Date.now();
      };

      const onTouchMove = (e) => {
        if (isAnimating) return;
        if (this.stickyContent.getBoundingClientRect().top > 0) return;

        const currentY = e.touches[0].clientY;
        const diff = startY - currentY;
        const absDiff = Math.abs(diff);

        const atTop = this.lastActiveIndex === 0;
        const atBottom = this.lastActiveIndex === this.media.length - 1;

        const slidingDown = diff < 0;
        const slidingUp = diff > 0;

        let shouldPrevent = false;
        if (!atTop && !atBottom) {
          shouldPrevent = true;               // 中间滑动，全部阻止
        } else if (atTop && slidingUp) {
          shouldPrevent = true;               // 顶部向上滑
        } else if (atBottom && slidingDown) {
          shouldPrevent = true;               // 底部向下滑
        }

        if (shouldPrevent && absDiff > 5) {
          e.preventDefault();
        }
      };

      const onTouchEnd = (e) => {
        if (isAnimating) return;
        if (this.stickyContent.getBoundingClientRect().top > 0) return;

        const endY = e.changedTouches[0].clientY;
        const diff = startY - endY;
        const absDiff = Math.abs(diff);
        const timeDiff = Date.now() - startTime;

        const isValidSwipe = absDiff >= MIN_SWIPE || (absDiff >= 10 && timeDiff < 200);
        if (!isValidSwipe) return;

        const direction = diff > 0 ? 1 : -1;
        let nextIndex = this.lastActiveIndex + direction;
        nextIndex = Math.max(0, Math.min(nextIndex, this.media.length - 1));

        if (nextIndex === this.lastActiveIndex) return;

        isAnimating = true;
        this.switchToIndex(nextIndex);
        this.lastActiveIndex = nextIndex;

        // 直接设置滚动位置，不依赖 smooth 动画
        const targetScrollY = nextIndex * this._perHeight;
        window.scrollTo({ top: targetScrollY + this._sectionTop, behavior: 'auto' });

        setTimeout(() => {
          isAnimating = false;
        }, LOCK_DURATION);
      };

      this.addEventListener('touchstart', onTouchStart, { passive: false });
      this.addEventListener('touchmove', onTouchMove, { passive: false });
      this.addEventListener('touchend', onTouchEnd, { passive: false });

      this._swipeHandlers = { onTouchStart, onTouchMove, onTouchEnd };

      // 移动端 scroll 同步
      this._mobileScrollTicking = false;
      this._mobileScrollHandler = (e) => {
        if (!this._mobileScrollTicking) {
          requestAnimationFrame(() => {
            this.onMobileScroll(e);
            this._mobileScrollTicking = false;
          });
          this._mobileScrollTicking = true;
        }
      };
      window.addEventListener("scroll", this._mobileScrollHandler, { passive: false });
    }

    onMobileScroll(e) {
      if (this._isLocked) return;
      if (this._isSnapping) {
        e.preventDefault();
        return;
      }

      const offsetTop = this.getBoundingClientRect().top;
      const scrollY = Math.abs(offsetTop);

      // 离开 sticky 区域时，重置到第一张图
      if (this.stickyContent.getBoundingClientRect().top > 100) {
        this.imageScrollContainer.style.setProperty("--current-index", "0");

        this.contents.forEach((content, index) => {
          if (index !== 0) {
            content.classList.add("yg-opacity-0");
          } else {
            content.classList.remove("yg-opacity-0");
          }
        });

        this.lastActiveIndex = 0;
        this.setBackground(0); // 重置背景色
        return;
      }


      // 还没进入 sticky 置顶状态时，不切换
      if (this.stickyContent.getBoundingClientRect().top > 0) {
        return;
      }

      const stepHeight = this._perHeight;

      let rawIndex = Math.round(scrollY / stepHeight);
      rawIndex = Math.max(0, Math.min(rawIndex, this.media.length - 1));

      if (rawIndex === this.lastActiveIndex) return;

      this.contents.forEach((c) => c.classList.add("yg-display-none"));
      this.contents[rawIndex].classList.remove("yg-display-none");

      // 先锁定滚动位置再执行切换，防止继续滚动跳过多张
      this._isSnapping = true;
      const targetScrollY = rawIndex * stepHeight;
      window.scrollTo({ top: targetScrollY + this._sectionTop, behavior: "auto" });

      setTimeout(() => {
        this._isSnapping = false;
      }, 300);

      const prevIndex = this.lastActiveIndex;
      this.lastActiveIndex = rawIndex;

      if (this.times.length > 0 && this.times[rawIndex]) {
        const currentTimeStr = this.times[rawIndex].getAttribute("data-time");
        const prevTimeStr = this.times[prevIndex].getAttribute("data-time");
        const currentTime = this.parseTime(currentTimeStr);
        const prevTime = this.parseTime(prevTimeStr);

        const activeTimeItem = this.times[rawIndex];
        const textColor = activeTimeItem.style.getPropertyValue("--text-color");
        const dotColor = activeTimeItem.style.getPropertyValue("--dot-color");

        const timeShow = this.querySelector(".yg-time-show");
        const timeShowMb = this.querySelector(".yg-time-show-mb");
        const timeColor = this.querySelector(".yg-time-color");
        const timeColorMb = this.querySelector(".yg-time-color-mb");

        if (timeShow) timeShow.style.color = textColor;
        if (timeShowMb) timeShowMb.style.color = textColor;
        if (timeColor) timeColor.style.setProperty("--dot-color", dotColor);
        if (timeColorMb) timeColorMb.style.setProperty("--dot-color", dotColor);

        this.animateClock(prevTime.hour, prevTime.minute, currentTime.hour, currentTime.minute, 800);
      }

      this.imageScrollContainer.style.setProperty("--current-index", rawIndex);

      this.switchVideo(prevIndex, rawIndex);
      this.setBackground(rawIndex);
    }

    handleAnchorTab() {
      const anchorTab = document.querySelector('.yg-anchor-tab');
      if (!anchorTab) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {

            // 进入可视区域
            if (entry.isIntersecting) {
              anchorTab.classList.add('hide');
            } else {
              // 离开可视区域
              anchorTab.classList.remove('hide');
            }

          });
        },
        {
          threshold: 0.2 // 可调：20%进入就触发（移动端推荐）
        }
      );

      observer.observe(this);
    }

    setBackground(activeIndex) {

      // 优先使用传入的索引，否则使用 lastActiveIndex
      const targetIndex = activeIndex !== undefined 
        ? activeIndex 
        : this.lastActiveIndex;

      if (targetIndex < 0 || !this.media[targetIndex]) return;

      const bgColor =
        this.media[targetIndex].getAttribute("data-background") || "#ffffff";

      this.stickyContent.style.backgroundColor = bgColor;
    }

    /* -----------------------------
       Scroll 监听 (rAF 优化)
    ----------------------------- */

    handleScroll() {
      console.log("window.innerWidth: ", window.innerWidth)

      window.addEventListener("scroll", () => {

        if (!this._scrollTicking) {

          requestAnimationFrame(() => {

            this.onScroll();

            this._scrollTicking = false;
          });

          this._scrollTicking = true;
        }
      });
    }

    /* -----------------------------
       切换锁定机制
    ----------------------------- */
    lockSwitch() {
      this._isLocked = true;
      setTimeout(() => {
        this._isLocked = false;
      }, 200);
    }

    /* -----------------------------
       Scroll 主逻辑
    ----------------------------- */

    onScroll() {

      // 锁定期间忽略滚动
      if (this._isLocked) return;

      const offsetTop = this.getBoundingClientRect().top;
      const scrollY = Math.abs(offsetTop);

      this.setAttribute("data-scroll-top", scrollY);

      // 未进入 sticky 区域
      if (this.stickyContent.getBoundingClientRect().top > 100) {

        this.imageScrollContainer.style.setProperty(
          "--current-index",
          "0"
        );

        this.contents.forEach((content, index) => {

          if (index !== 0) {
            content.classList.add("yg-opacity-0");
          } else {
            content.classList.remove("yg-opacity-0");
          }

        });

        this.lastActiveIndex = 0;
        this.setBackground(0); // 重置背景色

        return;
      }


      /* -----------------------------
         新的 index 计算方式（关键）
         根据滚动距离直接算 index
      ----------------------------- */

      const stepHeight =
        this.media[0].getBoundingClientRect().height / 2;

      let rawIndex = Math.floor(scrollY / stepHeight);

      rawIndex = Math.max(
        0,
        Math.min(rawIndex, this.media.length - 1)
      );


      /* -----------------------------
         限制一次只能切换 1 个
         防止快速滚动跳过
      ----------------------------- */

      let limitedActiveIndex = this.lastActiveIndex;

      if (rawIndex > this.lastActiveIndex) {
        limitedActiveIndex = this.lastActiveIndex + 1;
      }

      if (rawIndex < this.lastActiveIndex) {
        limitedActiveIndex = this.lastActiveIndex - 1;
      }

      limitedActiveIndex = Math.max(
        0,
        Math.min(limitedActiveIndex, this.media.length - 1)
      );


      /* -----------------------------
         没变化就不执行
      ----------------------------- */

      if (limitedActiveIndex === this.lastActiveIndex) return;


      /* -----------------------------
         以下全部保留你的原逻辑
      ----------------------------- */

      this.contents.forEach((c) =>
        c.classList.add("yg-display-none")
      );

      this.contents[limitedActiveIndex].classList.remove(
        "yg-display-none"
      );

      const prevIndex = this.lastActiveIndex;

      /* 时间动画 */
      if (this.times.length > 0 && this.times[limitedActiveIndex]) {
        const currentTimeStr = this.times[limitedActiveIndex].getAttribute("data-time");
        const prevTimeStr = this.times[prevIndex].getAttribute("data-time");
        const currentTime = this.parseTime(currentTimeStr);
        const prevTime = this.parseTime(prevTimeStr);
        const activeTimeItem = this.times[limitedActiveIndex];
        const textColor = activeTimeItem.style.getPropertyValue("--text-color");
        const dotColor = activeTimeItem.style.getPropertyValue("--dot-color");

        const timeShow = this.querySelector(".yg-time-show");
        const timeShowMb = this.querySelector(".yg-time-show-mb");
        const timeColor = this.querySelector(".yg-time-color");
        const timeColorMb = this.querySelector(".yg-time-color-mb");

        if (timeShow) timeShow.style.color = textColor;
        if (timeShowMb) timeShowMb.style.color = textColor;
        if (timeColor) timeColor.style.setProperty("--dot-color", dotColor);
        if (timeColorMb) timeColorMb.style.setProperty("--dot-color", dotColor);

        this.animateClock(prevTime.hour, prevTime.minute, currentTime.hour, currentTime.minute, 800);
      }

      /* 图片滚动 */
      this.imageScrollContainer.style.setProperty(
        "--current-index",
        limitedActiveIndex
      );


      /* 视频切换 */
      this.switchVideo(
        prevIndex,
        limitedActiveIndex
      );


      this.lastActiveIndex = limitedActiveIndex;


      /* 锁定，防止一帧触发多次 */
      this.lockSwitch();

    }
  }

  if (!window.customElements.get("yg-time-change")) {
    window.customElements.define(
      "yg-time-change",
      YGTimeChange
    );
  }
});

